function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _pt from "prop-types";
var _excluded = ["id", "children", "className", "mainGrid", "gutterSize", "gutters", "justify", "vAlign"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classNames from 'classnames';
import "./gridRow.css";
/**
 * @see [LMDS GridRow documentation and examples](https://designsystem.lmig.com/components/grids/code)
 *
 * API:
 * @implements [GridRowProps](https://designsystem.lmig.com/components/grids/code#grid-row-props)
 * @extends [HTMLDivElement](https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.htmldivelement.html)
 */
export var GridRow = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classNames;
  var id = _ref.id,
    children = _ref.children,
    className = _ref.className,
    _ref$mainGrid = _ref.mainGrid,
    mainGrid = _ref$mainGrid === void 0 ? false : _ref$mainGrid,
    _ref$gutterSize = _ref.gutterSize,
    gutterSize = _ref$gutterSize === void 0 ? 'default' : _ref$gutterSize,
    _ref$gutters = _ref.gutters,
    gutters = _ref$gutters === void 0 ? false : _ref$gutters,
    _ref$justify = _ref.justify,
    justify = _ref$justify === void 0 ? 'start' : _ref$justify,
    _ref$vAlign = _ref.vAlign,
    vAlign = _ref$vAlign === void 0 ? 'stretch' : _ref$vAlign,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  // We put this deprecation warning in the render function rather than useEFfect to support server components.
  if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production') {
    if (!gutters && gutterSize !== 'default') {
      // `gutters` could be boolean or string
      // On mobile, using gutterSize without gutters causes content to expand outside columns.
      // To avoid a breaking change, we're printing a warning but leaving these styles in place.
      console.warn('`gutterSize` is set but gutters are disabled, which may cause unexpected behavior. Consider either enabling gutters or removing `gutterSize`. In a future version of LMDS Grid, `gutterSize` will only have an effect if gutters are enabled.');
    }
  }
  var classes = classNames((_classNames = {
    'lm-Row': true,
    'lm-Row--main': mainGrid,
    'lm-Row--gutters': gutters === true
  }, _defineProperty(_classNames, "lm-Row--gutters-".concat(gutterSize), gutterSize === 'fixed-16' || gutterSize === 'small' || gutterSize === 'extra-small'), _defineProperty(_classNames, 'lm-Row--gutters-vertical', gutters === 'vertical'), _defineProperty(_classNames, 'lm-Row--gutters-horizontal', gutters === 'horizontal'), _defineProperty(_classNames, "lm-Row--".concat(justify), justify), _defineProperty(_classNames, "lm-Row--".concat(vAlign), vAlign), _classNames), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    className: classes,
    ref: ref
  }, otherProps), children);
});
GridRow.propTypes = {
  /** Add an optional ID to this element. */id: _pt.string,
  /** Add custom classes to this element. */className: _pt.string,
  /**
     * Use this to enforce a centered grid with a specified maximum width and external left and right margins.
     * Best used for page-level containers.
     * @default false
     */
  mainGrid: _pt.bool,
  /**
     * LMDS specifies a default gutters of 16px on desktop and 8px on mobile.
     * If necessary, you may override this with fixed-16 (16px at all breakpoints), small, or extra-small gutters.
     * @default 'default'
     */
  gutterSize: _pt.oneOf(['default', 'fixed-16', 'small', 'extra-small']),
  /**
     * Passing a boolean of 'true' will give you gutters around all four sides of your cells.
     * Alternatively, you can specify gutters between rows (horizontal) or between cells (vertical).
     * @default false
     */
  gutters: _pt.oneOfType([_pt.bool, _pt.oneOf(['vertical']), _pt.oneOf(['horizontal'])]),
  /**
     * In cases where flex-box GridCol properties are specified, these prop values help align your content properly.
     * @default 'start'
     */
  justify: _pt.oneOf(['start', 'center', 'end', 'around', 'between']),
  /**
     * In cases where flex-box GridCol properties are specified, these prop values help align your content properly.
     * @default 'stretch'
     */
  vAlign: _pt.oneOf(['stretch', 'top', 'middle', 'bottom', 'baseline']),
  /** Only GridCol components should be passed as direct children. */children: _pt.node
};
GridRow.displayName = 'GridRow';